var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-status",class:[_vm.cssClasses, _vm.statusClass, _vm.sizeClass]},[_c('span',{staticClass:"product-status__icon"}),(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }